import { useState, useMemo, useEffect } from "react";
import { FormulaDisplay } from "./FormulaDisplay";
import { ParsedMetric } from "./metrics.types";
import { AccountLabelFetch } from "./components/AccountLabelFetch";
import { SourceFile } from "../InvestmentMemo/components/SourceFile";
import { selectedPeriodAtom } from "./metrics.state";
import { useSetAtom } from "jotai";
import { rightDrawerOpenAtom } from "@/features/Navigation/state";

export function MetricLineage({ metric }: { metric: ParsedMetric }) {
    const setRightDrawerOpen = useSetAtom(rightDrawerOpenAtom);
    const setSelectedPeriod = useSetAtom(selectedPeriodAtom);
    // Find the first value with metadata (clickable value)
    const firstClickableRef = useMemo(() => {
        const firstWithMeta = metric.values.find((v) => v.meta);
        return firstWithMeta?.ref || "$0";
    }, [metric.values]);

    const [selectedRef, setSelectedRef] = useState<string>(firstClickableRef);

    // Reset selection to first value when metric changes
    useEffect(() => {
        setSelectedRef(firstClickableRef);
    }, [metric, firstClickableRef]);

    const selectedValue = metric.values.find(
        (value) => value.ref === selectedRef,
    );
    const fileId = selectedValue?.meta?.dataAssetId;
    const accountId = selectedValue?.meta?.accountId;

    return (
        <div className="mt-1 flex flex-col gap-2">
            <FormulaDisplay
                metric={metric as ParsedMetric}
                onValueClick={(value) => {
                    setSelectedRef(value.ref);
                }}
                selectedRef={selectedRef}
            />
            {accountId && <AccountLabelFetch accountId={accountId} />}
            {fileId && (
                <SourceFile
                    fileId={fileId}
                    onSelect={() => {
                        setSelectedPeriod(null);
                        setRightDrawerOpen(false);
                    }}
                />
            )}
        </div>
    );
}
